export default "__VITE_ASSET__BCh0tQ7P__"